import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { ContactsPageContent } from "@/features/contacts";
import { NoContactsContent } from "@/features/no-contacts-content";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { ContactsPageMobile } from "@/pages/ContactsPage/mobile";
import { useContactsPage } from "../model";
import styles from "./styles.module.scss";

export const ContactsPageV2 = () => {
  const { isLoading, isEmpty } = useContactsPage();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={styles["loader"]}>
        <Spin size="large" />
      </div>
    );
  }

  if (isEmpty) {
    return (
      <ResponsiveBlockSwitcher
        desktop={
          <NoContactsContent message={t("contactsPage.noContacts")} isAddContact isImportEnabled />
        }
        mobile={<ContactsPageMobile />}
      />
    );
  }

  return <ContactsPageContent />;
};
